import { defineStore } from 'pinia';

type state = {
  type: 'success' | 'warning' | 'error' | 'info' | '';
  title: string;
  msg: string;
  link: {
    url: string;
    text: string;
  };
  isCloseable: boolean;
};

export const useNotificationStore = defineStore('notifications', {
  state: (): state => ({
    type: '',
    title: '',
    msg: '',
    isCloseable: false,
    link: {
      url: '',
      text: '',
    },
  }),
  actions: {
    setNewNotification(newNotification: state) {
      this.type = newNotification.type;
      this.title = newNotification.title;
      this.msg = newNotification.msg;
      this.isCloseable = newNotification.isCloseable;
      this.link.url = newNotification.link.url;
      this.link.text = newNotification.link.text;
    },
    setStandardErrorNotification() {
      if (!this.title && !this.msg) {
        this.type = 'error';
        this.title = 'Ett fel uppstod';
        this.msg = 'Ett fel uppstod, vänligen försök igen';
        this.isCloseable = true;
        this.link.url = 'https://www.halebop.se/support';
        this.link.text = 'Om felet kvarstår kontakta supporten';
      }
    },
    setErrorNotificationFromCatchClause(msg?: string, title?: string) {
      const defaultMsg = 'Ett fel uppstod, vänligen försök igen';
      const defaultTitle = 'Ett fel uppstod';

      this.type = 'error';
      this.title = title ?? defaultTitle;
      this.msg = msg ?? defaultMsg;
      this.isCloseable = msg ? true : false;
      this.link = {
        url: 'https://www.halebop.se/support',
        text: 'kontakta supporten',
      };
    },
    setErrorFromLookup(errorname: string) {
      const errorKey = errorname.toLowerCase();
      if (errorKey === 'netaxept') {
        this.type = 'error';
        this.title = 'Något oförutsett har visst inträffat :(';
        this.msg =
          'Det gick inte att slutföra din betalning. Var god försök igen eller byt betalmetod.';
        this.isCloseable = false;
        this.link.url = 'https://www.halebop.se/support';
        this.link.text = 'Om felet kvarstår kontakta supporten';
      } else {
        this.setStandardErrorNotification();
      }
    },
    reset() {
      this.type = '';
      this.title = '';
      this.msg = '';
      this.isCloseable = false;
      this.link.url = '';
      this.link.text = '';
    },
  },
});
